import { NotifyManager } from 'notify-component';
import { isManager } from '#app/helpers/isManager';
import { isProfileFilled } from '#app/helpers/isProfileFilled';
import { routes } from '#app/constants/routes';

export const handleRouteClick = (url, client, authData, navigate) => {
  if (!client && isManager(authData)) {
    if (url === routes.accounting.clients) {
      navigate(url);
      return;
    }
    NotifyManager.error('', 'Выберите клиента');
    return;
  }

  if (isProfileFilled(client) || url === routes.register.page1 || isManager(authData)) {
    navigate(url);
  } else {
    NotifyManager.error('', 'Заполните профиль');
  }
};
